import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export default {
  namespaced: true,
  state() {
    return {
      open: false,
      manualDocked: null,
      conversationId: null,
      messages: [],
      isSending: false,
      dockedWidth: 384,
      quota: null,
      // What the assistant offers to do on the resource on screen (an invoice),
      // worked out by the back when it sends that resource
      suggestedActions: [],
      suggestedActionsResource: null,
      // A direct action picked in the bubble, run by the view that owns its UI
      requestedSuggestedAction: null
    }
  },
  mutations,
  actions,
  getters
}
